<template>
  <div
    class="mobile-enquiry-button pt-3 px-3 flex shadow-bar-bottom"
    :class="className"
  >
    <template v-if="$store.getters.isRtbFlowPossible">
      <div class="w-1/2">
        <EnquiryPricingMobileBar />
      </div>

      <BaseButton
        style="min-width: 180px;"
        color="red"
        class="flex-grow"
        size="large"
        @click="submit('request_to_book_button')"
      >
        Request to book
      </BaseButton>
    </template>

    <template v-else>
      <AddToFavouritesSmall class="mr-1" />

      <BaseButton
        :reduced-paddings="true"
        color="red"
        class="flex-grow"
        size="large"
        @click="submit($store.getters.isWedding ? 'request_brochure_button' : 'enquire_now_button')"
      >
        {{ $store.getters.isWedding ? 'Request a free brochure' : 'Enquire now' }}
      </BaseButton>
    </template>
  </div>
</template>

<script>
import BaseButton from '@/components/Ui/Buttons/BaseButton.vue';

import EnquiryPricingMobileBar from '../EnquiryPricingMobileBar.vue';
import AddToFavouritesSmall from './AddToFavouritesSmall.vue';

export default {
  name: 'MobileBottomButton',
  emits: ['click'],
  components: {
    EnquiryPricingMobileBar,
    AddToFavouritesSmall,
    BaseButton,
  },
  props: {
    isVisible: {
      type: Boolean,
      default: false,
    },
  },

  computed: {
    className() {
      if (this.isVisible) {
        return '';
      }
      return 'mobile-enquiry-button--invisible';
    },
  },
  methods: {
    track(element) {
      this.$store.dispatch('trackGA4Interaction', {
        section: 'mobile_widget',
        element,
        value: null,
        interaction: 'click',
      });
    },
    submit(trackingElement) {
      this.$emit('click');
      this.track(trackingElement);
    },
  },
};
</script>

<style lang="scss" scoped>
.mobile-enquiry-button {
  z-index: 1000;
  position: fixed;
  bottom: 0;
  background: white;
  left: 0;
  right: 0;
  transition: transform 0.2s ease-out;
  transform: translateY(0);

  padding-bottom: 12px;
  @supports (padding: env(safe-area-inset-bottom)) {
    padding-bottom: calc(12px + env(safe-area-inset-bottom)) !important;
  }
}

.mobile-enquiry-button--invisible {
  transform: translateY(100%);
}
</style>
